import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomBreadcrumb from "../common/CustomBreadcrumb";
import Alert from "../common/Alert";
import { Container, Spinner } from 'react-bootstrap';
import ResponsiveTable from "../Grid/ResponsiveTable";
import { addVendorCode, getVendorCodes, updateVendorCode } from "../../services/vendor-service";
import VendorForm from './VendorForm';
import { validIndicatorStatus } from '../../helpers/formatter';
import editIcon from "../../assets/edit.svg"
import constants, { ACTIVE, INACTIVE } from '../../helpers/constants';
import { formatDateTime } from "../../helpers/date-formatter";
import Loader from '../common/loader';


export default function VendorMaster() {

  const [action, setAction] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [rowData, setRowData] = useState({});
  const [reload, setReload] = useState(false);
  const [data, setData] = useState([]);
  const [indicator, setIndicator] = useState(["Y","N"]);
  const navigate = useNavigate();


  const [headers] = useState([
    { displayName: "Status", columnName: "validIndicator", dataType: "text", status: true, switch: true, setStatus: setStatus, width: 120, displayIndication: true, formatter: validIndicatorStatus },
    { displayName: "Vendor Code", columnName: "vendorCode", dataType: "text", width: 200, displayIndication: true },
    { displayName: "Vendor Name", columnName: "vendorName", dataType: "text", width: 200, displayIndication: true },
    { displayName: "Modified By", columnName: "modifiedBy", dataType: "text", width: 150, displayIndication: true },
    { displayName: "Modified On", columnName: "modifiedOn", dataType: "date", width: 180, displayIndication: true, formatter: formatDateTime},
    { displayName: "Validation Channel", columnName: "validationChannel", dataType: "text", width: 180, displayIndication: true }
  ]);

  const handleAdd = () => {
    setAction("Add");
    setShowForm(true);
  };

  useEffect(() => {
    getVendor();
  }, [reload]);
 const getVendor = async () => {
    console.log("inside getvendor")
    setLoading(true)
    let result = await getVendorCodes().catch((error) => Alert("error", error))
      console.log("result inside getVendor",result)
    if (result) {
      setData(result)
    }
    setLoading(false)
  };

  async function setStatus(item) {
    console.log("setStatus item", item)   
    setLoading(true);
    if (item.validIndicator  === constants.ACTIVE  ) {
      item.validIndicator = 'Y' 
    } else if (item.validIndicator === constants.INACTIVE) {
      item.validIndicator = 'N'
    }
    updateVendorCode(item)
  .then(async (result) => {
    console.log("updateVendorCode result", result);
    Alert("success", "Status updated successfully");
    await getVendor();
  })
  .catch((error) => {
    Alert("error", error);
  })
  .finally(() => {
    setLoading(false);
  });
  }

  let icons = [{ src: editIcon, click: edit }]

  function edit(item){
    setAction("Edit");
    setRowData(item);
    setShowForm(true);
  }

  return (
    <>
        {loading && <Loader/>}
      {/* {loading && <div className="spinner-box"> <Spinner animation="border" className="spinner">
      </Spinner></div>} */}

      {showForm && (
        <VendorForm
          show={showForm}
          action={action}
          rowdata={rowData}
          setReload={() => setReload(!reload)}
          vendordata={data}
          indicator={indicator}
          onHide={() => setShowForm(false)}
        />
      )}

      <CustomBreadcrumb parentMenu={"Maintenance"} menu={"Maintain Vendor Details"}> </CustomBreadcrumb>
      <Container bsPrefix="main-body">
        <div className="page-title">Vendor</div>
        <div className="page-sub-title">Add or Edit Vendor Details</div>
        <ResponsiveTable headers={headers} data={data} icons={icons} dataType={"Vendor"} button={"New Vendor"} handleAdd={handleAdd} sessionName={"Maintain Vendor Details"}></ResponsiveTable>
      </Container>
    </>
  )
}
